import Contest from 'umg-ember-backend/components/record-explorer/for/contest';

<template><Contest @records={{@model}} @recordType='contest' /></template>
